import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {TaakGeschiedenis, TaakGeschiedenisDto} from './taak-geschiedenis';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TaakGeschiedenisService {
  private http = inject(HttpClient);

  getTaakGeschiedenis$(clientId: string): Observable<TaakGeschiedenis> {
    return this.http.get<TaakGeschiedenisDto>(`${environment.apiUrl}/taakgeschiedenis/${clientId}`)
      .pipe(map(dto => TaakGeschiedenis.deserialize(dto)));
  }
}
